<div class="card">
    <div class="card_body">
        <form class="form">
            <div class="form_group fz_s">
                <label class="row inp_group row_ai_center">
                    <div class="col-4 lbl lbl_mb_0">Имя</div>
                        <div class="row row_inp col-17">
                            <input type="text" class="inp" placeholder="John" name="firstname" [(ngModel)]="customerForm.firstname" (ngModelChange)="onCustomerInfoChange('firstname')">
                            <input type="text" class="inp" placeholder="Doe" name="lastname" [(ngModel)]="customerForm.lastname" (ngModelChange)="onCustomerInfoChange('lastname')">
                        </div>
                    <div class="col-1"><button class="btn_close" (click)="addAdditionalNames()"><span class="material-symbols-outlined">
                        add
                    </span></button></div>
                    <div class="col-2 quantity">
                        <button (click)="toggleAdditional('names')" *ngIf="additionalInformation.names.length > 0" class="dark_btn row row_ai_center row_jc_center" type="button">+{{additionalInformation.names.length}}</button>
                    </div>
                </label>
                <ng-container *ngIf="additionalInfoVisible.names">
                    <label *ngFor="let additionalName of additionalInformation.names; let i = index">
                        <div class="row inp_group row_ai_center">
                            <div class="col-4"></div>
                            <div class="row row_inp col-17">
                                <input type="text" class="inp" placeholder="John" name="additional_firstname-{{i}}"
                                    [(ngModel)]="additionalName.firstname"
                                    (ngModelChange)="onCustomerInfoChange('additional_firstname', i)">
                                <input type="text" class="inp" placeholder="Doe" name="aditional_lastname-{{i}}"
                                    [(ngModel)]="additionalName.lastname" (ngModelChange)="onCustomerInfoChange('additional_lastname', i)">
                            </div>
                            <div class="col-3"><button type="button" class="btn_red" (click)="removeAdditionalInfo('names', i)"><span
                                        class="material-symbols-outlined color_red">
                                        delete
                                    </span></button></div>
                        </div>
                    </label>
                </ng-container>
                <label class="row inp_group row_ai_center">
                    <div class="col-4 lbl lbl_mb_0">Телефон</div>
                    <div class="col-17">
                    <app-input-tel name="phone" [phoneValue]="customerForm.phone" [phoneCode]="customerForm.phone?.[0]" (phoneValueChange)="customerForm.phone = $event"
                        (changeCustomerPhone)="onCustomerInfoChange('phone')">
                    </app-input-tel>
                    </div>
                    <div class="col-1"><button class="btn_close" type="button" (click)="addAdditionalPhones()"><span class="material-symbols-outlined">
                        add
                    </span></button></div>
                    <div class="col-2 quantity">
                        <button (click)="toggleAdditional('phones')" *ngIf="additionalInformation.phones.length > 0" class="dark_btn row row_ai_center row_jc_center"
                            type="button">+{{additionalInformation.phones.length}}</button>
                    </div>
                </label>
                <ng-container *ngIf="additionalInfoVisible.phones">
                    <label *ngFor="let phone of additionalInformation.phones; let i = index; trackBy: trackByIndex">
                        <div class="row inp_group row_ai_center">
                            <div class="col-4"></div>
                            <div class="col-17">
                            <app-input-tel [phoneCode]="additionalInformation.phones[i][0]" [name]="'additional_phone-' + i" [phoneValue]="additionalInformation.phones[i]"
                                (phoneValueChange)="additionalInformation.phones[i] = $event"
                                (changeCustomerPhone)="onCustomerInfoChange('additional_phone', i)">
                            </app-input-tel>
                            </div>
                            <div class="col-3"><button type="button" class="btn_red" (click)="removeAdditionalInfo('phones', i)"><span
                                        class="material-symbols-outlined color_red">
                                        delete
                                    </span></button></div>
                        </div>
                    </label>
                </ng-container>
                <label class="row inp_group row_ai_center">
                    <div class="col-4 lbl lbl_mb_0">Имейл</div>
                    <div class="col-17"><input type="email" placeholder="example@example.com" class="inp" name="email" [(ngModel)]="customerForm.email" (ngModelChange)="onCustomerInfoChange('email')"></div>
                    <div class="col-1"><button class="btn_close" type="button" (click)="addAdditionalEmails()"><span class="material-symbols-outlined">
                        add
                    </span></button></div>
                    <div class="col-2 quantity">
                        <button (click)="toggleAdditional('emails')" *ngIf="additionalInformation.emails.length > 0" class="dark_btn row row_ai_center row_jc_center"
                            type="button">+{{additionalInformation.emails.length}}</button>
                    </div>
                </label>
                <ng-container *ngIf="additionalInfoVisible.emails">
                    <label *ngFor="let email of additionalInformation.emails; let i = index; trackBy: trackByIndex">
                        <div class="row inp_group row_ai_center">
                            <div class="col-4"></div>
                            <div class="row row_inp col-17">
                                <input type="text" class="inp" placeholder="example@example.com" name="additional_email-{{i}}"
                                    [(ngModel)]="additionalInformation.emails[i]"
                                    (ngModelChange)="onCustomerInfoChange('additional_email', i)">
                            </div>
                            <div class="col-3"><button type="button" class="btn_red" (click)="removeAdditionalInfo('emails', i)"><span
                                        class="material-symbols-outlined color_red">
                                        delete
                                    </span></button></div>
                        </div>
                    </label>
                </ng-container>
                <label class="row inp_group row_ai_center">
                    <div class="col-4 lbl lbl_mb_0">Адрес</div>
                    <div class="col-17"><input type="text" placeholder="99 Wall Street, #5553, New York, NY, 10005" class="inp" name="address" [(ngModel)]="customerAddress.street" (ngModelChange)="onCustomerInfoChange('address')"></div>
                    <div class="col-1"><button class="btn_close" type="button" (click)="addAdditionalAddresses()"><span class="material-symbols-outlined">
                        add
                    </span></button></div>
                    <div class="col-2 quantity">
                        <button (click)="toggleAdditional('addresses')" *ngIf="additionalInformation.addresses.length > 0" class="dark_btn row row_ai_center row_jc_center"
                            type="button">+{{additionalInformation.addresses.length}}</button>
                    </div>
                </label>
                <ng-container *ngIf="additionalInfoVisible.addresses">
                    <label *ngFor="let address of additionalInformation.addresses; let i = index; trackBy: trackByIndex">
                        <div class="row inp_group row_ai_center">
                            <div class="col-4"></div>
                            <div class="row row_inp col-17">
                                <input type="text" class="inp" placeholder="99 Wall Street, #5553, New York, NY, 10005"
                                    name="additional_address-{{i}}" [(ngModel)]="additionalInformation.addresses[i]"
                                    (ngModelChange)="onCustomerInfoChange('additional_address', i)">
                            </div>
                            <div class="col-3"><button type="button" class="btn_red" (click)="removeAdditionalInfo('addresses', i)"><span
                                        class="material-symbols-outlined color_red">
                                        delete
                                    </span></button></div>
                        </div>
                    </label>
                </ng-container>
                <label class="row inp_group row_ai_center">
                    <div class="col-4 lbl lbl_mb_0">Статус</div>
                    <div class="col-17">
                        <select name="status" class="inp" [compareWith]="compareByKey" (change)="onCustomerInfoChange('status')" [(ngModel)]="customerForm.status">
                            <option *ngFor="let status of optionsStatus" [ngValue]="status">{{status.name}}</option>
                        </select>
                    </div>
                    <div class="col-3"></div>
                </label>
                <label class="row inp_group row_ai_center">
                    <div class="col-4 lbl lbl_mb_0"> Источник</div>
                    <div class="col-17">
                        <select name="utmMetadata" [compareWith]="compareByKey" class="inp" (change)="onCustomerInfoChange('utmMetadata')" [(ngModel)]="customerForm.utmMetadata">
                            <option *ngFor="let s of sources" [ngValue]="s">{{s.source}}</option>
                        </select>
                    </div>
                    <div class="col-3"></div>
                </label>
            </div>
            <div *ngIf="btnsVisible" class="btns_container row fw_500 fz_s">
                <button (click)="resetForm()" class="btn btn_cancel">Очистить</button>
                <button (click)="updateCustomer()" [disabled]="isLoadingSend" class="btn dark_btn row"><span *ngIf="isLoadingSend" class="loader"></span> <span *ngIf="!isLoadingSend">Сохранить</span></button>
            </div>
            <div *ngIf="restoreBtnVisible" class="btns_container row fw_500 fz_s">
                <button (click)="restoreForm()" class="btn dark_btn">Вернуть</button>
            </div>
        </form>
    </div>
</div>
